// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import { onIdTokenChanged, getFhirId } from "./services/firebase";

/* eslint-disable */
if (!!process.env.REACT_APP_ANALYTICS_GTM_ID) {
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    const f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(
    window,
    document,
    "script",
    "dataLayer",
    process.env.REACT_APP_ANALYTICS_GTM_ID
  );
}

onIdTokenChanged(async (user) => {
  const userId = await getFhirId(user);
  if (userId) {
    window.dataLayer?.push?.({ userId });
  }
});
